import React from 'react';
import {connect} from 'react-redux';
import Store from './store';
import {getStaffRewardOutlet} from '../../actions/staff';
import ManageRewards from './manage-rewards';

const StoreList = (props) => {
  const onManageClicked = (storeId, row) => {
    props.dispatch(getStaffRewardOutlet(storeId, row));
  };
  // eslint-disable-next-line react/jsx-one-expression-per-line
  let storeItems = [<h1 key={0}>Loading...</h1>];

  if (props.fetched) {
    storeItems = [[]];
    props.stores.forEach((store, index) => {
      if (index > 0 && !(index % 4)) {
        storeItems.push([]);
      }
      storeItems[storeItems.length - 1].push(<Store
        key={store.id}
        onManageClicked={onManageClicked}
        open={props.manageStoreId === store.id}
        row={storeItems.length - 1}
        store={store}
      />);
    });
  }

  return (
    <div className="store-list">
      {storeItems.map((store, index) => (
        <div key={`container-${index}`}>
          <div className="row manage-staff-rewards-row" key={`row-${index}`}>
            {store}
          </div>
          <div className="row manage-staff-rewards-row" key={`edit-${index}`}>
            {index === props.manageRow && <ManageRewards open={index === props.manageRow}/>}
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  manageRewardsVisible: state.staff.staffRewards.manageRewardsVisible,
  manageRow: state.staff.staffRewards.manageRow,
  manageStoreId: state.staff.staffRewards.manageStoreId
});

export default connect(mapStateToProps)(StoreList);



// WEBPACK FOOTER //
// ./src/components/staff-rewards/store-list.jsx